import { useState } from "react";
import { Identifier, InterpType } from "../../interpretation/interpretable";
import { Draggable } from "../dragdrop";
import { useInterpretable } from "../flowchart";

export function IdentifierComponent({ data }: { data: string }) {
  const [identifier, setData] = useInterpretable<Identifier>(data);
  const [state, setState] = useState(false);

  if (!identifier) {
    // I believe a rerender is triggered when:
    // the internal assignment context map has changed,
    // the node's uuid has changed.
    // as such this is a problem as we have multiple rerenders. debugging needed to prevent this.
    console.log("identifier none?");
    return <></>;
  }

  return <Draggable of={data}>
    <input type="text" value={identifier.data.name} onChange={(event) => {
      setData({
        name: event.target.value
      })
      setState(!state);
    }}
    style={{width: "75%"}}
    />
  </Draggable>
}